import { Component } from '@angular/core';

@Component({
    selector: 'twitch-icon',
    template: '<img src="/assets/svgs/socials/twitch.svg" height=27 width=27>',
    styleUrls: ['../svg.component.scss']
})
export class TwitchIcon {

}